"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _localizations = _interopRequireDefault(require("./localizations"));

var _htmlDecoderHelper = require("@eig-builder/core-utils/helpers/html-decoder-helper");

var _get = _interopRequireDefault(require("lodash/get"));
/**
 * allows us to perform a string format in the tranlsation message
 *
 * @export
 * @param {string} message - text that will be displayed
 * @param {string} key - message key, fallback if the message was unknown on the server
 * @param {array} values - arr of values that will be formatted
 * @returns {string} formatted message
 */


function _default(message, key, values) {
  // find fallback
  if (!message) {
    message = (0, _get["default"])(_localizations["default"].get(), key, null);
  }

  if (message) {
    if ((0, _typeof2["default"])(values) === 'object') {
      if (values.constructor === Array) {
        if (values.length) {
          message = _stringFormat(message, values);
        }
      } else {
        return _stringFormatObject(message, values);
      }
    } // Sometimes message is an object. Don't try to decodeHtml


    if ((0, _typeof2["default"])(message) === 'object') {
      return key;
    }

    return (0, _htmlDecoderHelper.decodeHtml)(message);
  }

  return key;
}
/**
 * allows us to perform a string format in the tranlsation message
 *
 * @export
 * @param {string} message - the translated message which contains '{text}' parts that will be replaced bij values of the next parameter (object)
 * @param {object} object - the object that hold keys that will be merged into the message
 * @returns {string} formatted message, the object properies will be merged into the message.
 * This result is a new string or an array. If the object contains properties which are objects then
 * this will result in an array of strings plus objects
 */


var _stringFormatObject = function _stringFormatObject(message, object) {
  var array;

  for (var key in object) {
    var localKey = "{".concat(key, "}");
    var value = object[key];

    if ((0, _typeof2["default"])(value) === 'object') {
      if (!array) {
        var split = message.split(localKey);

        if (split.length === 1) {
          array = [split[0]];
        } else {
          array = [split[0], value, split[1]];
        }
      } else {
        var _split = array.pop().split(localKey);

        if (_split.length < 2) {
          array.push(" |".concat(localKey, " not found in translation| "));
          array.push(_split[0]);
        } else {
          array.push(_split[0]);
          array.push(value);
          array.push(_split[1]);
        }
      }
    } else {
      var regex = new RegExp(localKey, 'ig');

      if (!array) {
        message = message.replace(regex, value);
      } else {
        var lastIndex = array.length - 1;
        array[lastIndex] = array[lastIndex].replace(regex, value);
      }
    }
  }

  return array ? array.map(function (item) {
    if (typeof item === 'string') {
      return (0, _htmlDecoderHelper.decodeHtml)(item);
    }

    return item;
  }) : (0, _htmlDecoderHelper.decodeHtml)(message);
};

var _stringFormat = function _stringFormat(message, values) {
  return message.replace(/{(\d+)}/g, function (match, number) {
    return typeof values[number] !== 'undefined' ? values[number] : match;
  });
};